module.exports = "/_next/static/images/img__timer-21c5a0405fb3aa79fc4b852177326701.png";